// extracted by mini-css-extract-plugin
export default {"productGallery":"dM-z","inQuickShop":"eM-z"};